import React from "react";
import PropTypes from "prop-types";

import Fieldset from "../../common/Fieldset";
import TextAreaInput from "../../common/TextAreaInput";
import Section from "../../common/Section";
import Form from "../../common/Form";
import RadioButtonText from "../../common/RadioButtonText";
import * as domainConstants from "../../../constants/DomainConstants";

const VRBeoordelingscriteriaForm = (props) => {
	const {
		vrBeoordelingscriteria,
		disabled,
		errors,
		onChange,
		onSave,
		color,
		sportVlaanderenIconsURL,
		validationMessageType
	} = props;

	const jaNee = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];
	const dossierType = vrBeoordelingscriteria.typeDossier;
	const isNietTopsport = dossierType == domainConstants.DOSSIER_TYPE_AANVRAAG_BOVENLOKAAL_RENOVATIE || dossierType == domainConstants.DOSSIER_TYPE_AANVRAAG_BOVENLOKAAL_NIEUWBOUW;

	return (
		<Section title="Vul het inhoudelijk voortgangsrapport in" color={color} disabled={disabled}>
			<Form
				title="Invulformulier beoordelingscriteria"
				name="beoordelingscriteria"
				rightButtonLabel="Bewaar"
				onRightButtonClick={onSave}
				rightButtonDisabled={disabled}>
				<Fieldset title="Zijn er wijzigingen m.b.t. het criterium behoefte van je project ?">
					<RadioButtonText
						label=""
						name="wijzigingenCriteriaBehoefte"
						value={vrBeoordelingscriteria.wijzigingenCriteriaBehoefte}
						onChange={onChange}
						disabled={disabled}
						items={jaNee}
						horizontal
						validationMessage={errors ? errors.wijzigingenCriteriaBehoefte : ''}
						validationMessageType={validationMessageType}
						nameJa="toelichtingWijzigingenCriteriumBehoefte"
						valueJa={vrBeoordelingscriteria.toelichtingWijzigingenCriteriumBehoefte}
						labelJa="Toelichting (max 1500 tekens)"
						errorJa={errors ? errors.toelichtingWijzigingenCriteriumBehoefte : ''}
					/>
				</Fieldset>
				{isNietTopsport ?
					<Fieldset title="Zijn er wijzigingen m.b.t. het criterium bereik van je project ?">
						<RadioButtonText
							label=""
							name="wijzigingenCriteriaBereik"
							value={vrBeoordelingscriteria.wijzigingenCriteriaBereik}
							onChange={onChange}
							disabled={disabled}
							items={jaNee}
							horizontal
							validationMessage={errors ? errors.wijzigingenCriteriaBereik : ''}
							validationMessageType={validationMessageType}
							nameJa="toelichtingWijzigingenCriteriumBereik"
							valueJa={vrBeoordelingscriteria.toelichtingWijzigingenCriteriumBereik}
							labelJa="Toelichting (max 1500 tekens)"
							errorJa={errors ? errors.toelichtingWijzigingenCriteriumBereik : ''}
						/>
					</Fieldset>
					:
					null}
				{isNietTopsport ?
					<Fieldset title="Licht de stand van zaken/nieuwste ontwikkelingen toe inzake de samenwerkingsverbanden m.b.t. je project.">
						<TextAreaInput
							label="Realisatie van het project (max 1500 tekens)"
							name="realisatieProject"
							value={vrBeoordelingscriteria.realisatieProject}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.realisatieProject : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
						<TextAreaInput
							label="Exploitatie van het project (max 1500 tekens)"
							name="exploitatieProject"
							value={vrBeoordelingscriteria.exploitatieProject}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.exploitatieProject : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
						<TextAreaInput
							label="Andere samenwerkingsverbanden (vb. financieel, intergemeentelijk, intersectoraal,... )
						(max 1500 tekens)"
							name="andereSamenwerkingsverbanden"
							value={vrBeoordelingscriteria.andereSamenwerkingsverbanden}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.andereSamenwerkingsverbanden : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
					</Fieldset>
					:
					null}
				{isNietTopsport ?
					<Fieldset title="Integrale toegankelijkheid">
						<TextAreaInput
							label="Licht de stand van zaken toe inzake de acties die bijdragen tot een inclusief aanbod voor bezoekers.
						(max 1500 tekens)"
							name="actiesInclusiefAanbodBezoekers"
							value={vrBeoordelingscriteria.actiesInclusiefAanbodBezoekers}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.actiesInclusiefAanbodBezoekers : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
						<TextAreaInput
							label="Licht de stand van zaken toe hoe je de integrale toegankelijkheid van de infrastructuur en omgeving garandeert. (max 1500 tekens)"
							name="integraleToegankelijkheidInfrastructuur"
							value={vrBeoordelingscriteria.integraleToegankelijkheidInfrastructuur}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.integraleToegankelijkheidInfrastructuur : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
					</Fieldset>
					:
					null}
				{isNietTopsport ?
					<Fieldset title="Licht de stand van zaken/nieuwste ontwikkelingen toe inzake de innovatieve eigenschappen m.b.t. je project.">
						<TextAreaInput
							label="Gebouw ( architectuur, gebouw, ecologie, duurzaamheid, technologie, gebruikte materialen, clustering,....)
						(max 1500 tekens)"
							name="innovatieveEigenschappenGebouw"
							value={vrBeoordelingscriteria.innovatieveEigenschappenGebouw}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.innovatieveEigenschappenGebouw : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
						<TextAreaInput
							label="Exploitatie (max 1500 tekens)"
							name="innovatieveEigenschappenExploitatie"
							value={vrBeoordelingscriteria.innovatieveEigenschappenExploitatie}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.innovatieveEigenschappenExploitatie : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
						<TextAreaInput
							label="Sporttechnisch / sporttakken / sporten (max 1500 tekens)"
							name="innovatieveEigenschappenSporttechnisch"
							value={vrBeoordelingscriteria.innovatieveEigenschappenSporttechnisch}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.innovatieveEigenschappenSporttechnisch : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
						<TextAreaInput
							label="Samenwerkingsverbanden (max 1500 tekens)"
							name="innovatieveEigenschappenSamenwerkingSV"
							value={vrBeoordelingscriteria.innovatieveEigenschappenSamenwerkingSV}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.innovatieveEigenschappenSamenwerkingSV : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
						<TextAreaInput
							label="Trends (max 1500 tekens)"
							name="innovatieveEigenschappenTrends"
							value={vrBeoordelingscriteria.innovatieveEigenschappenTrends}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.innovatieveEigenschappenTrends : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
						<TextAreaInput
							label="Maatschappelijke innovatie (max 1500 tekens)"
							name="innovatieveEigenschappenMaatschappelijkeInnovatie"
							value={vrBeoordelingscriteria.innovatieveEigenschappenMaatschappelijkeInnovatie}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.innovatieveEigenschappenMaatschappelijkeInnovatie : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
					</ Fieldset>
					:
					null}
				{isNietTopsport ?
					null
					:
					<Fieldset title="Zijn er wijzigingen m.b.t. de prioritaire ter beschikkingstelling van je project ?">
						<RadioButtonText
							label=""
							name="wijzigingenMbtPrioritaireBeschikking"
							value={vrBeoordelingscriteria.wijzigingenMbtPrioritaireBeschikking}
							onChange={onChange}
							disabled={disabled}
							items={jaNee}
							horizontal
							validationMessage={errors ? errors.wijzigingenMbtPrioritaireBeschikking : ''}
							validationMessageType={validationMessageType}
							nameJa="toelichtingWijzigingenPrioritaireBeschikking"
							valueJa={vrBeoordelingscriteria.toelichtingWijzigingenPrioritaireBeschikking}
							labelJa="Toelichting (max 1500 tekens)"
							errorJa={errors ? errors.toelichtingWijzigingenPrioritaireBeschikking : ''}
						/>
					</Fieldset>
				}
				{isNietTopsport ?
					null
					:
					<Fieldset title="Licht de stand van zaken/ nieuwste ontwikkelingen toe inzake het één-campusmodel m.b.t. je project.">
						<TextAreaInput
							label="Toelichting (max 500 tekens)"
							name="toelichtingEenCampusmodel"
							value={vrBeoordelingscriteria.toelichtingEenCampusmodel}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.toelichtingEenCampusmodel : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
					</Fieldset>
				}
				{isNietTopsport ?
					null
					:
					<Fieldset title="Licht de stand van zaken toe inzake de kwaliteitsontwikkeling en innovatie van je project.">
						<TextAreaInput
							label="Kwaliteit van de topsportinfrastructuur (max 1500 tekens)"
							name="kwaliteitVanDeTopsportinfrastructuur"
							value={vrBeoordelingscriteria.kwaliteitVanDeTopsportinfrastructuur}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.kwaliteitVanDeTopsportinfrastructuur : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
						<TextAreaInput
							label="Nieuwe of opkomende sporten/disciplines (max 1500 tekens)"
							name="nieuweOfOpkomendeSportendisciplines"
							value={vrBeoordelingscriteria.nieuweOfOpkomendeSportendisciplines}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.nieuweOfOpkomendeSportendisciplines : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
						<TextAreaInput
							label="Nieuwe technologieën (max 1500 tekens)"
							name="nieuweTechnologien"
							value={vrBeoordelingscriteria.nieuweTechnologien}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.nieuweTechnologien : ''}
							validationMessageType={validationMessageType}
							disabled={disabled}
							height={4}
						/>
					</Fieldset>
				}
				<Fieldset title="Bij welke communicatie gebruik(te) je het logo van Sport Vlaanderen ?"
					tooltip="Communicatie over het gesubsidieerde project zoals bepaald in het ministerieel besluit dat je bij de selectiebeslissing hebt ontvangen."
					tooltipWindowWidth={35}
					linkText="Download logo"
					linkUrl={sportVlaanderenIconsURL}>
					<TextAreaInput
						label="Bij welke communicatie gebruik(te) je het logo van Sport Vlaanderen ? (max 250 tekens)"
						name="toelichtingCommunicatieLogoSV"
						value={vrBeoordelingscriteria.toelichtingCommunicatieLogoSV}
						onChange={onChange}
						size={12}
						validationMessage={errors ? errors.toelichtingCommunicatieLogoSV : ''}
						validationMessageType={validationMessageType}
						disabled={disabled}
						height={4}
					/>
				</Fieldset>
				<Fieldset title="Opmerkingen">
					<TextAreaInput
						label="Opmerkingen (max 500 tekens)"
						name="opmerkingen"
						value={vrBeoordelingscriteria.opmerkingen}
						onChange={onChange}
						size={12}
						validationMessage={errors ? errors.opmerkingen : ''}
						validationMessageType={validationMessageType}
						disabled={disabled}
						height={4}
						optional
					/>
				</Fieldset>
			</Form>
		</Section>
	);
};

VRBeoordelingscriteriaForm.propTypes = {
	vrBeoordelingscriteria: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	onChange: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	color: PropTypes.string.isRequired,
	sportVlaanderenIconsURL: PropTypes.string,
	validationMessageType: PropTypes.string
};

export default VRBeoordelingscriteriaForm;